import { createFileRoute } from "@tanstack/react-router";
import DemoGratuit from "@/pages/DemoGratuit";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/demo-gratuit/")({
  head: () => routeHead("/uk/demo-gratuit/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DemoGratuit />
  );
}
